import styled from 'styled-components'

import { Box } from '~components/atoms/box'

export const StyledGroup = styled(Box)``
